import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

const irregularRegExp = /[[\]\\?*()+.$^|%@]/gi;

Highlight.propTypes = {
  original: PropTypes.string.isRequired,
  keyword: PropTypes.string.isRequired,
};
export default function Highlight({ original, keyword }) {
  const replacedKeyword = keyword.replace(irregularRegExp, (val) => {
    return `\\${val}`;
  });
  const re = new RegExp(
    `(${(replacedKeyword || '').trim().split(/\s+/).join('|')})`,
    'gi',
  );
  const namePartials = original.split(re);

  return namePartials.map((partial, id) => (
    <Fragment key={id}>
      {re.test(partial) ? <em className="keyword">{partial}</em> : partial}
    </Fragment>
  ));
}
